import styled from '@emotion/styled';
import { colors } from 'crono-fe-common/theme';

export const InformationBadgeWrapper = styled.span`
  display: flex;
  height: fit-content;
  cursor: pointer;
  path {
    stroke: ${colors.grey11};
  }

  &:hover {
    path {
      stroke: ${colors.black};
    }
  }
`;
